import RawHtml from '../HelperComponents/RawHtml';

const AdminHtmlPage = () => {
  return <RawHtml page={'home'} />;
};

export default AdminHtmlPage;
